import { jsx as _jsx } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";
export const IconTooltip = ({ arrow = true, children, ml, onClick, placement, title, trigger, ...props })=>{
    return /*#__PURE__*/ _jsx(MuiTooltip, {
        arrow: arrow,
        enterTouchDelay: 0,
        onClick: onClick,
        placement: placement,
        title: title || children,
        children: /*#__PURE__*/ _jsx(IconButton, {
            ...props,
            disableRipple: true,
            size: props.size ?? 'small',
            sx: {
                ml: ml ?? 0.25,
                padding: 0
            },
            children: trigger ?? /*#__PURE__*/ _jsx(InfoOutlined, {
                color: "primary",
                fontSize: "small"
            })
        })
    });
};
IconTooltip.displayName = 'IconTooltip';

//# sourceMappingURL=IconTooltip.js.map